import React, { useState } from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { IProductInstructions } from "../../../all-types";



const ProductInstructionsForm: React.FC<{
    instructions: IProductInstructions,
    setInstructions: (data: IProductInstructions) => void
}> = ({instructions, setInstructions}) => {
//   const [instructions, setInstructions] = useState<IProductInstructions>({});
  const [newHeading, setNewHeading] = useState("");

  const handleAddHeading = () => {
    if (!newHeading.trim()) return;
    if (instructions[newHeading]) return;

    setInstructions({
      ...instructions,
      [newHeading]: [""]
    });
    setNewHeading("");
  };

  const handleInstructionChange = (
    heading: string,
    index: number,
    value: string
  ) => {
    const updated = [...instructions[heading]];
    updated[index] = value;
    setInstructions({
      ...instructions,
      [heading]: updated
    });
  };

  const handleAddInstruction = (heading: string) => {
    setInstructions({
      ...instructions,
      [heading]: [...instructions[heading], ""]
    });
  };

  const handleRemoveInstruction = (heading: string, index: number) => {
    const updated = instructions[heading].filter((_, i) => i !== index);
    setInstructions({
      ...instructions,
      [heading]: updated.length > 0 ? updated : [""]
    });
  };

  const handleRemoveHeading = (heading: string) => {
    const updated = { ...instructions };
    delete updated[heading];
    setInstructions(updated);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Product Instructions
      </Typography>

      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <TextField
          label="New Heading"
          value={newHeading}
          onChange={(e) => setNewHeading(e.target.value)}
        />
        <Button variant="contained" onClick={handleAddHeading}>
          Add Heading
        </Button>
      </Box>

      {Object.entries(instructions)?.map(([heading, list]) => (
        <Box key={heading} sx={{ mb: 3, border: "1px solid #ccc", p: 2, borderRadius: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              {heading}
            </Typography>
            <IconButton onClick={() => handleRemoveHeading(heading)}>
              <DeleteIcon />
            </IconButton>
          </Box>

          {list.map((instruction, index) => (
            <Box key={index} sx={{ display: "flex", gap: 1, mb: 1 }}>
              <TextField
                fullWidth
                label={`Instruction ${index + 1}`}
                value={instruction}
                onChange={(e) =>
                  handleInstructionChange(heading, index, e.target.value)
                }
              />
              <IconButton onClick={() => handleRemoveInstruction(heading, index)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}

          <Button
            startIcon={<AddIcon />}
            onClick={() => handleAddInstruction(heading)}
          >
            Add Instruction
          </Button>
        </Box>
      ))}

      {/* <Typography variant="body1" sx={{ mt: 4 }}>
        <pre>{JSON.stringify(instructions, null, 2)}</pre>
      </Typography> */}
    </Box>
  );
};

export  {ProductInstructionsForm};
